import React from "react";
import { Link } from "react-router-dom";

export default function AdminNavbar() {
  return (
    <nav className="bg-blue-700 text-white p-4 flex justify-between">
      <h1 className="text-xl font-semibold">Admin Panel</h1>
      <div className="space-x-4">
        <Link to="/admin/dashboard" className="hover:underline">Dashboard</Link>
        <Link to="/admin/qrscanner" className="hover:underline">QR Scanner</Link>
        <Link to="/" className="hover:underline">Logout</Link>
      </div>
    </nav>
  );
}
